// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__arIyO","dragIcon":"Choice_dragIcon__2GgqI","left":"Choice_left__17wyg","input":"Choice_input__13OOe"};